module.exports = __webpack_public_path__ + "img/Mstorybg801.32164807.png";